var map = {
	"./CodeForces.svg": 7792,
	"./Facebook.svg": 2015,
	"./Instagram.svg": 7797,
	"./LeetCode.jpeg": 1151,
	"./Linkedsvg.svg": 2470,
	"./TS-Healthcare.jpeg": 8775,
	"./Twitter.svg": 408,
	"./black-jack.png": 9992,
	"./chat.png": 8753,
	"./counter.png": 6767,
	"./github.svg": 3322,
	"./gridpathfinder.png": 5330,
	"./leetcode.svg": 5994,
	"./linkedin.svg": 9705,
	"./me.jpeg": 5174,
	"./me1.jpeg": 6793,
	"./moon.png": 3496,
	"./patatap.png": 2672,
	"./pathfinder.png": 5538,
	"./portfolio.png": 3827,
	"./promptexai.png": 4308,
	"./rb.png": 1303,
	"./sun.png": 2873,
	"./todo.png": 1603,
	"./wave.svg": 9680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;